<template>
  <ak-type-input hideLabel v-model="_value" :field="customerField" />
</template>
<script>
export default {
  data () {
    return {
      customerField: {
        name: 'state', // 表单字段名，必填，用来分辨不同的input
        note: '状态', // 表单显示的名称，如果为空则显示表单name
        type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
        items: {
          'bePaid': '待支付',
          'completed': '已完成'
        }
      }
    }
  },
  methods: {
    // 自定义搜索组件必须实现 filterQuery方法
    // filterQuery方法返回的值就是where中对应的字段的查询语句
    // 如：下面直接返回value，生成的where语句为 { sex: value }
    // 如果不返回值，则不会生成该字段的搜索条件
    filterQuery () {
      if (this._value) return this._value
    }
  },
  syncProps: ['value'], // 这是admin-tk自带的加强功能，具体用法查看下方说明
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object // 当前field对象
  }
}
</script>
